import React from "react";
import { cn } from "../../../lib/cn";

/**
 * EmptyState — ui-v2.5. Ausencia de datos, 3 intensidades según si hay acción posible.
 * Especificación: ui-v2.5-catalogo-componentes.html · sección EmptyState.
 * REGLA: vive DENTRO del contenedor de la tabla, no lo sustituye.
 *
 * <EmptyState variant="full" icon={UserPlus} title="Sin incorporaciones registradas"
 *             description="Cuando solicites datos…" action={<Button>Nueva incorporación</Button>} />
 * <EmptyState variant="medium" title="Sin resultados para los filtros aplicados." action={<Button variant="ghost">Limpiar</Button>} />
 * <EmptyState variant="minimal" title="Sin bajas registradas." />
 */

export function EmptyState({ variant = "full", icon: Icon, title, description, action, className }) {
  if (variant === "full") {
    return (
      <div className={cn("px-6 py-12 text-center", className)}>
        {Icon && (
          <div className="mx-auto mb-3 grid h-12 w-12 place-items-center rounded-v25-full bg-v25-surface-raised">
            <Icon className="h-6 w-6 text-v25-ink-400" />
          </div>
        )}
        {title && <p className="mb-1 text-sm font-medium text-v25-ink-700">{title}</p>}
        {description && <p className="mx-auto mb-4 max-w-sm text-xs text-v25-ink-500">{description}</p>}
        {action}
      </div>
    );
  }
  // medium (con acción ghost) | minimal (solo texto)
  return (
    <div className={cn("px-6 py-10 text-center", className)}>
      <p className="text-sm text-v25-ink-500">{title || description}</p>
      {variant === "medium" && action && <div className="mt-2">{action}</div>}
    </div>
  );
}
